<template>
  <div>
    <h1 class="page-header">{{ $t('studentCardActivator.cardActivator') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              :leave="route_leave"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-6 com-md-9 col-sm-12 d-flex justify-content-start"
              ></div>
              <div
                class="col-lg-6 com-md-3 col-sm-12 d-flex justify-content-end"
              >
                <select
                  class="form-control"
                  v-model.number="status_id"
                  style="width: 120px"
                >
                  <option value disabled selected style="display: none">
                    {{ $t('select') }}
                  </option>
                  <option
                    v-for="(status, index) in cardStatus"
                    :key="index"
                    :value="status.card_status_id"
                  >
                    {{ status.card_status }}
                  </option>
                </select>
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 300px"
                  class="ml-2"
                />
                <ts-button
                  outline
                  class="ml-2"
                  v-tooltip="$t('filter')"
                  @click.prevent="visible = true"
                >
                  <i class="fa fa-filter"></i>
                </ts-button>
              </div>
            </div>
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-loading-banner :loading="exporting">
              <Table
                :columns="columns"
                :data="resources"
                :loading="loading"
                max-height="700"
                stripe
                highlight-row
                size="small"
              >
                <template slot-scope="{ row }" slot="branch_name_en">
                  {{ row.branch ? row.branch.branch_name_en : '' }}
                </template>
                <template slot-scope="{ row }" slot="card_number">
                  {{
                    row.student_profile ? row.student_profile.card_number : ''
                  }}
                </template>
                <template slot-scope="{ row }" slot="full_name_in_fo">
                  {{
                    row.student_profile
                      ? row.student_profile.full_name_en +
                        '|' +
                        row.student_profile.full_name_kh
                      : ''
                  }}
                </template>
                <template slot-scope="{ row }" slot="status_id">
                  <span class="label label-success" v-if="row.status_id == 1"
                    >Active</span
                  >
                  <span class="label label-default" v-if="row.status_id == 2"
                    >Inactive</span
                  >
                </template>
                <template slot-scope="{ row }" slot="action">
                  <a
                    href="#"
                    v-tooltip="$t('studentCardActivator.changeStatus')"
                    class="text-primary ts-mr-3"
                    @click.prevent="change(row)"
                  >
                    <i class="fas fa-random"></i>
                  </a>
                  <a
                    href="#"
                    v-tooltip="$t('studentCardActivator.deleted')"
                    class="text-danger"
                    @click.prevent="destroy(row)"
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </template>
              </Table>
            </ts-loading-banner>
            <div class="d-flex justify-content-between align-items-center p-15">
              
              <ts-pagination
                v-model="pagination"
                @navigate="fetchData"
              ></ts-pagination>
            </div>
          </div>
        </ts-card>
        <!-- drawer -->
        <a-drawer
          :title="$t('invoice.filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="() => (visible = false)"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <a-select
                  style="width: 257px"
                  v-model="branch_id"
                  :options="branchs"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                >
                </a-select>
              </div>
            </div>
          </div>
        </a-drawer>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'
import FormChange from './change.vue'
import FormDeleted from './destroy-modal.vue'

export default {
  components: {
    FormCreate
  },
  name: 'student-card-activator',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      route_leave: false,
      branchs: [],
      visible: false,
      exporting: false
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchResourceBeforeCreate()
    this.getBranch()
  },
  computed: {
    ...mapState('studentCardActivator', [
      'resources',
      'pagination',
      'cardStatus'
    ]),
    columns() {
      return [
        {
          title: this.$t('studentCardActivator.branch'),
          slot: 'branch_name_en',
          minWidth: 80
        },
        {
          title: this.$t('studentCardActivator.cardNumber'),
          slot: 'card_number',
          minWidth: 70
        },
        {
          title: this.$t('studentCardActivator.studentName'),
          slot: 'full_name_in_fo',
          minWidth: 120
        },
        {
          title: this.$t('studentCardActivator.serialCard'),
          key: 'serial_card',
          minWidth: 70,
          align: 'center'
        },
        {
          title: this.$t('studentCardActivator.registerDate'),
          key: 'registered_date',
          minWidth: 60,
          align: 'center'
        },
        {
          title: this.$t('studentCardActivator.status'),
          slot: 'status_id',
          minWidth: 30,
          align: 'center'
        },
        {
          title: this.$t('studentCardActivator.reason'),
          key: 'reason',
          minWidth: 60
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 100
        }
      ]
    },
    search: {
      get() {
        return this.$store.state.studentCardActivator.search
      },
      set(newVal) {
        this.$store.commit('studentCardActivator/SET_SEARCH', newVal)
        this.$store.commit('studentCardActivator/RESET_CURRENT_PAGE')
      }
    },
    status_id: {
      get() {
        return this.$store.state.studentCardActivator.status_id
      },
      set(newVal) {
        this.$store.commit('studentCardActivator/SET_STATUS_ID', newVal)
      }
    },
    branch_id: {
      get() {
        return this.$store.state.studentCardActivator.branch_id
      },
      set(newValue) {
        this.$store.commit('studentCardActivator/SET_BRANCH_ID', newValue)
      }
    }
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.$store
        .dispatch('studentCardActivator/dataBeforeCreate')
        .then(() => {
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch(
          'studentCardActivator/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    change(data) {
      this.$modal.show(
        FormChange,
        {
          data: data
        },
        {
          height: 'auto',
          width: '330px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    destroy(data) {
      this.$modal.show(
        FormDeleted,
        {
          data: data
        },
        {
          height: 'auto',
          width: '330px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({
        search,
        branch_id: this.branch_id
      })
    }, 500),
    status_id: debounce(function(val) {
      this.fetchData({ val, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'student-card-activator-create') {
      this.$store.commit('studentCardActivator/RESET_STATE')
      this.$store.commit('studentCardActivator/SET_STUDENTS', [])
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
